import {
  PATIENT_FIELD_RETRIEVED,
  PRESCRIPTION_FIELD_RETRIEVED,
  FREE_SHIPPING_SETTINGS_RECEIVED,
  DATE_FORMAT_APPLIED,
  SCHOOL_RETRIEVED,
  REMEMBER_SETTINGS_RECEIVED,
} from "../constants/types/settingsType";

const initialState = {
  patientFormFields: [],
  prescriptionFormFields: [],
  freeShippingSettings: [],
  schools: [],
  dateFormat: "",
  rememberSettings: [],
};

export const settingsReducers = (state = initialState, action) => {
  switch (action.type) {
    case PATIENT_FIELD_RETRIEVED:
      return {
        ...state,
        patientFormFields: action.payload,
      };
    case PRESCRIPTION_FIELD_RETRIEVED:
      return {
        ...state,
        prescriptionFormFields: action.payload,
      };
    case FREE_SHIPPING_SETTINGS_RECEIVED:
      return {
        ...state,
        freeShippingSettings: action.payload,
      };
    case SCHOOL_RETRIEVED:
      return {
        ...state,
        schools: action.payload,
      };
    case DATE_FORMAT_APPLIED:
      return {
        ...state,
        dateFormat: action.payload,
      };
    case REMEMBER_SETTINGS_RECEIVED:
      return {
        ...state,
        rememberSettings: action.payload,
      };
    default:
      return state;
  }
};
